/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Keep_DownloadingInputs */

const en_mobile_keep_downloading = /** @type {(inputs: Mobile_Keep_DownloadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep downloading`)
};

const es_mobile_keep_downloading = /** @type {(inputs: Mobile_Keep_DownloadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguir descargando`)
};

/**
* | output |
* | --- |
* | "Keep downloading" |
*
* @param {Mobile_Keep_DownloadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_keep_downloading = /** @type {((inputs?: Mobile_Keep_DownloadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Keep_DownloadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_keep_downloading(inputs)
	return en_mobile_keep_downloading(inputs)
});